'use client';

import useScrollTriggerRefresh from '@/hooks/useScrollTriggerRefresh';

const ScrollTriggerRefresher = () => {
  useScrollTriggerRefresh();

  return null;
};

export default ScrollTriggerRefresher;
